import {configureStore} from '@reduxjs/toolkit'
import * as InstallationReducers from './reducers/InstallationReducers'
import * as DesignReducers from "./reducers/DesignReducers";
import * as AdminReducers from "./reducers/AdminReducers";
import * as JobReducers from "./reducers/JobReducers";
import * as EmployeeReducers from "./reducers/EmployeeReducers";
import * as PrintingReducers from "./reducers/PrintingReducers";


export const Store = configureStore({
    reducer: {
        //installation
        jobListSkim: InstallationReducers.JobListSkimReducer,
        jobListUnassigned: InstallationReducers.JobListUnassignedReducer,
        jobListAssigned: InstallationReducers.JobListAssignedReducer,
        jobListCompleted: InstallationReducers.JobListCompletedReducer,
        accountList: InstallationReducers.AccountListReducer,
        installerList: InstallationReducers.InstallerListInstallerJobReducer,
        installerListVehicleEvents: InstallationReducers.InstallerListVehicleEventsReducer,
        vehicleList: InstallationReducers.VehicleListReducer,
        filter: InstallationReducers.FilterReducer,
        sort: InstallationReducers.SortReducer,


        adminjobCount: AdminReducers.jobCountSkimReducer,
        adminSortNew: AdminReducers.SortReducerIncomplete,
        adminSortComplete: AdminReducers.SortReducerComplete,
        adminSortFull: AdminReducers.SortReducerFull,
        adminSearchNew: AdminReducers.SearchReducerNew,
        adminSearchComplete: AdminReducers.SearchReducerComplete,
        adminSearchFull: AdminReducers.SearchReducerFull,

        designjobCount: DesignReducers.jobCountSkimReducer,
        designSortNew: DesignReducers.SortReducerIncomplete,
        designSortComplete: DesignReducers.SortReducerComplete,
        designSortFull: DesignReducers.SortReducerFull,
        designSearchNew: DesignReducers.SearchReducerNew,
        designSearchComplete: DesignReducers.SearchReducerComplete,
        designSearchFull: DesignReducers.SearchReducerFull,
        designJobFilterNew: DesignReducers.filterReducerNew,
        designJobFilterCompleted: DesignReducers.filterReducerCompleted,
        designJobFilterFull: DesignReducers.filterReducerFull,

        printjobCount: PrintingReducers.jobCountSkimReducer,
        printSortNew: PrintingReducers.SortReducerIncomplete,
        printSortComplete: PrintingReducers.SortReducerComplete,
        printSortFull: PrintingReducers.SortReducerFull,
        printSearchNew: PrintingReducers.SearchReducerNew,
        printSearchComplete: PrintingReducers.SearchReducerComplete,
        printSearchFull: PrintingReducers.SearchReducerFull,

        jobCount: JobReducers.jobCountSkimReducer,
        jobSortNew: JobReducers.SortReducerIncomplete,
        jobSortComplete: JobReducers.SortReducerComplete,
        jobSortFull: JobReducers.SortReducerFull,
        jobSearchNew: JobReducers.SearchReducerNew,
        jobSearchComplete: JobReducers.SearchReducerComplete,
        jobSearchFull: JobReducers.SearchReducerFull,

        employeeSort: EmployeeReducers.SortReducer,
        employeeSearch: EmployeeReducers.SearchReducer,
        employeeFilter: EmployeeReducers.FilterReducer,
        employeeAdd: EmployeeReducers.addEmployees,
        /*//misc
        overallJobList: JobReducers.JobListReducer,
        overallJobListSkim: JobReducers.JobListSkimReducer,
        adminListSkim: AdminReducers.JobListSkimReducer,
        adminList: AdminReducers.JobListReducer,*/
    }
})